import Navigation from "@/components/Navigation";
import ScrollProgress from "@/components/ScrollProgress";
import HexagonalGrid from "@/components/HexagonalGrid";
import SectionTransition from "@/components/SectionTransition";
import HeroSection from "@/components/HeroSection";
import PortfolioSection from "@/components/PortfolioSection";
import PainSection from "@/components/PainSection";
import ExpertiseSection from "@/components/ExpertiseSection";
import ProcessSection from "@/components/ProcessSection";
import ExperienceSection from "@/components/ExperienceSection";
import WhySection from "@/components/WhySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import { useFullPageScroll } from "@/hooks/useFullPageScroll";
import { ScrollProvider } from "@/contexts/ScrollContext";
import { useIsMobile } from "@/hooks/use-mobile";
import ScrollToTop from "@/components/ScrollToTop";

const sections = [
  { Component: HeroSection, scrollable: false },
  { Component: PainSection, scrollable: true },
  { Component: ExpertiseSection, scrollable: true },
  { Component: ProcessSection, scrollable: true },
  { Component: ExperienceSection, scrollable: false },
  { Component: WhySection, scrollable: false },
  { Component: TestimonialsSection, scrollable: true },
  { Component: PortfolioSection, scrollable: true },
  { Component: CTASection, scrollable: true }, // Make CTA scrollable
];

const Index = () => {
  const isMobile = useIsMobile();
  const { currentSection, goToSection } = useFullPageScroll({ 
    totalSections: sections.length,
    debounceDelay: 1000,
  });

  return (
    <ScrollProvider value={{ goToSection, currentSection }}>
      <HexagonalGrid />
      <ScrollProgress currentSection={currentSection} totalSections={sections.length} />
      <Navigation />
      <ScrollToTop />
      
      {isMobile ? (
        // Mobile: Normal scroll layout
        <div className="w-full">
          {sections.map(({ Component }, index) => (
            <div key={index} className="min-h-screen w-full">
              {index === sections.length - 1 ? (
                <div className="min-h-screen">
                  <Component />
                  <Footer />
                </div>
              ) : (
                <Component />
              )}
            </div>
          ))}
        </div>
      ) : (
        // Desktop: Full-page scroll layout
        <div className="fullpage-container">
          <div 
            className="fullpage-wrapper"
            style={{
              transform: `translateY(-${currentSection * 100}vh)`,
            }}
          >
            {sections.map(({ Component, scrollable }, index) => (
              <SectionTransition 
                key={index} 
                isActive={currentSection === index}
                scrollable={scrollable}
              >
                {index === sections.length - 1 ? (
                  <div className="min-h-screen">
                    <Component />
                    <Footer />
                  </div>
                ) : (
                  <Component />
                )}
              </SectionTransition>
            ))}
          </div>
        </div>
      )}
    </ScrollProvider>
  );
};

export default Index;
